<script lang="ts">
  // Aba Ranking - top 100 players por score ELO trucoxp.
  // Auto-refresh a cada 30s (ranking muda mais devagar que torneios).
  // Pausa quando aba nao ta visivel. Felipe 2026-05-28: tirou o botao
  // manual de recarregar — polui a tela.
  import { onMount, onDestroy } from 'svelte';
  import { ranking, rankingLoading, rankingError, loadRanking } from '../../stores/ranking';
  import { userId } from '../../stores/auth';
  import { Trophy, Medal, Crown } from 'lucide-svelte';

  const AUTO_REFRESH_MS = 30_000;
  let intervalId: number | null = null;

  function tick() {
    if (typeof document !== 'undefined' && document.hidden) return;
    void loadRanking();
  }

  onMount(() => {
    void loadRanking();
    intervalId = window.setInterval(tick, AUTO_REFRESH_MS);
  });

  onDestroy(() => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  });

  function avatarSrc(av?: string): string {
    return av ? `/images/${av}.webp` : '/images/character1.webp';
  }
</script>

<div class="ranking-tab">

  {#if $rankingError}
    <div class="error" role="alert">{$rankingError}</div>
  {/if}

  {#if $rankingLoading && $ranking.length === 0}
    <div class="empty">carregando...</div>
  {:else if $ranking.length === 0}
    <div class="empty">ninguém pontuou ainda — joga um torneio</div>
  {:else}
    {@const top3 = $ranking.slice(0, 3)}
    {@const rest = $ranking.slice(3)}

    {#if top3.length === 3}
      {@const first = top3[0]}
      {@const second = top3[1]}
      {@const third = top3[2]}
      <!-- Podium: 2º esquerda, 1º centro (maior), 3º direita -->
      <div class="podium">
        <!-- 2º lugar -->
        <div class="podium-card place-2" class:me={second.id === $userId}>
          <svg class="medal" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
              <linearGradient id="silver" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="#e8e8e8"/>
                <stop offset="50%" stop-color="#b0b0b0"/>
                <stop offset="100%" stop-color="#8a8a8a"/>
              </linearGradient>
            </defs>
            <path d="M22 4l-6 14 16 12 16-12-6-14H22z" fill="#90a4ae" stroke="#607d8b" stroke-width="2" stroke-linejoin="round"/>
            <circle cx="32" cy="40" r="18" fill="url(#silver)" stroke="#5d6e75" stroke-width="2.5"/>
            <text x="32" y="48" text-anchor="middle" font-family="Arial Black, sans-serif" font-size="20" font-weight="900" fill="#fff" stroke="#5d6e75" stroke-width="1">2</text>
          </svg>
          <img class="podium-avatar" src={avatarSrc(second.avatar)} alt={second.nickname} />
          <span class="podium-nick">{second.nickname}</span>
          <span class="podium-score">{second.score} pts</span>
          {#if second.id === $userId}<span class="me-tag">VOCÊ</span>{/if}
        </div>

        <!-- 1º lugar (centro, maior) -->
        <div class="podium-card place-1" class:me={first.id === $userId}>
          <svg class="crown" viewBox="0 0 80 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
              <linearGradient id="gold" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="#fff7ad"/>
                <stop offset="50%" stop-color="#ffd54f"/>
                <stop offset="100%" stop-color="#f9a825"/>
              </linearGradient>
            </defs>
            <path d="M8 50V20l12 12L40 12l20 20 12-12v30H8z" fill="url(#gold)" stroke="#e65100" stroke-width="2.5" stroke-linejoin="round"/>
            <circle cx="20" cy="22" r="3" fill="#ff5252" stroke="#b71c1c" stroke-width="1.5"/>
            <circle cx="40" cy="12" r="3" fill="#42A5F5" stroke="#0D47A1" stroke-width="1.5"/>
            <circle cx="60" cy="22" r="3" fill="#66bb6a" stroke="#1b5e20" stroke-width="1.5"/>
            <rect x="8" y="48" width="64" height="6" fill="#f9a825" stroke="#e65100" stroke-width="2"/>
          </svg>
          <img class="podium-avatar large" src={avatarSrc(first.avatar)} alt={first.nickname} />
          <span class="podium-nick large">{first.nickname}</span>
          <span class="podium-score large">{first.score} pts</span>
          {#if first.id === $userId}<span class="me-tag">VOCÊ</span>{/if}
        </div>

        <!-- 3º lugar -->
        <div class="podium-card place-3" class:me={third.id === $userId}>
          <svg class="medal" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
              <linearGradient id="bronze" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="#e8a87c"/>
                <stop offset="50%" stop-color="#cd7f32"/>
                <stop offset="100%" stop-color="#8b4513"/>
              </linearGradient>
            </defs>
            <path d="M22 4l-6 14 16 12 16-12-6-14H22z" fill="#a1887f" stroke="#5d4037" stroke-width="2" stroke-linejoin="round"/>
            <circle cx="32" cy="40" r="18" fill="url(#bronze)" stroke="#5d4037" stroke-width="2.5"/>
            <text x="32" y="48" text-anchor="middle" font-family="Arial Black, sans-serif" font-size="20" font-weight="900" fill="#fff" stroke="#5d4037" stroke-width="1">3</text>
          </svg>
          <img class="podium-avatar" src={avatarSrc(third.avatar)} alt={third.nickname} />
          <span class="podium-nick">{third.nickname}</span>
          <span class="podium-score">{third.score} pts</span>
          {#if third.id === $userId}<span class="me-tag">VOCÊ</span>{/if}
        </div>
      </div>
    {/if}

    <!-- Tabela com posições 4+ (ou todas se < 3 entries) -->
    <div class="table">
      <div class="thead">
        <span class="th pos">Pos</span>
        <span class="th player">Jogador</span>
        <span class="th score">Pontos</span>
      </div>
      <div class="tbody">
        {#each (top3.length === 3 ? rest : $ranking) as entry, idx (entry.id)}
          {@const pos = (top3.length === 3 ? 4 : 1) + idx}
          {@const isMe = entry.id === $userId}
          <div class="row" class:me={isMe}>
            <div class="cell pos">
              <span class="num">{pos}</span>
            </div>

            <div class="cell player">
              <img class="avatar" src={avatarSrc(entry.avatar)} alt={entry.nickname} />
              <span class="nick">{entry.nickname}</span>
              {#if isMe}<span class="me-tag">VOCÊ</span>{/if}
            </div>

            <div class="cell score">
              <Trophy size={12} strokeWidth={2.5} />
              <span>{entry.score}</span>
            </div>
          </div>
        {/each}
      </div>
    </div>
  {/if}
</div>

<style>
  .ranking-tab {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .error {
    color: var(--danger);
    background: rgba(255, 76, 126, 0.08);
    border: 1px solid rgba(255, 76, 126, 0.3);
    border-radius: var(--radius-md);
    padding: 10px 12px;
    font-size: 13px;
  }
  .empty {
    color: var(--text-dim);
    text-align: center;
    padding: 24px;
    font-size: 13px;
    border: 1px dashed var(--border);
    border-radius: var(--radius-md);
  }

  /* Podium top 3 — 2º esq, 1º centro (maior), 3º dir */
  .podium {
    display: grid;
    grid-template-columns: 1fr 1.25fr 1fr;
    gap: 10px;
    align-items: end;
    padding: 8px 4px 16px;
    margin-bottom: 4px;
  }
  .podium-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 12px 10px 14px;
    background: linear-gradient(180deg, #faf5ec 0%, #fff 100%);
    border-radius: 14px;
    position: relative;
    transition: transform 0.2s, box-shadow 0.2s;
  }
  .podium-card:hover { transform: translateY(-2px); }

  .place-1 {
    border: 3px solid #ffb300;
    box-shadow: 0 4px 0 #e65100, 0 8px 28px rgba(255, 179, 0, 0.4);
    transform: translateY(-12px); /* destaque vertical */
    padding-top: 16px;
  }
  .place-1:hover { transform: translateY(-14px); }
  .place-2 {
    border: 3px solid #90a4ae;
    box-shadow: 0 3px 0 #607d8b, 0 6px 16px rgba(120, 144, 156, 0.35);
  }
  .place-3 {
    border: 3px solid #b87333;
    box-shadow: 0 3px 0 #5d4037, 0 6px 16px rgba(184, 115, 51, 0.35);
  }

  .crown {
    width: 56px;
    height: 44px;
    margin-bottom: -4px;
    filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.25));
  }
  .medal {
    width: 44px;
    height: 44px;
    margin-bottom: -4px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.25));
  }

  .podium-avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #1565C0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    background: #faf5ec;
  }
  .podium-avatar.large {
    width: 72px;
    height: 72px;
    border: 4px solid #ffb300;
    box-shadow: 0 3px 10px rgba(255, 179, 0, 0.5);
  }
  .podium-nick {
    font-weight: 800;
    font-size: 13px;
    color: #0D47A1;
    text-align: center;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
  .podium-nick.large {
    font-size: 15px;
    color: #b8860b;
    text-shadow: 0 1px 0 rgba(255, 215, 0, 0.4);
  }
  .podium-score {
    font-size: 12px;
    font-weight: 800;
    color: #1976D2;
  }
  .podium-score.large {
    font-size: 14px;
    color: #e65100;
  }

  .podium-card.me {
    border-color: #2e7d32 !important;
    background: linear-gradient(180deg, rgba(76, 175, 80, 0.12), #fff);
  }
  .podium-card .me-tag {
    position: absolute;
    top: -8px;
    right: -4px;
    font-size: 9px;
    font-weight: 900;
    color: #fff;
    background: #2e7d32;
    padding: 2px 8px;
    border-radius: 999px;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 0 #1b5e20;
  }

  @media (max-width: 480px) {
    .podium { gap: 6px; padding: 6px 0 12px; }
    .podium-card { padding: 8px 4px 10px; gap: 4px; }
    .place-1 { transform: translateY(-8px); padding-top: 10px; }
    .crown { width: 44px; height: 36px; }
    .medal { width: 36px; height: 36px; }
    .podium-avatar { width: 42px; height: 42px; }
    .podium-avatar.large { width: 54px; height: 54px; }
    .podium-nick { font-size: 11px; }
    .podium-nick.large { font-size: 12px; }
    .podium-score { font-size: 10px; }
    .podium-score.large { font-size: 12px; }
  }

  /* Tabela estilo cartoon (consistente com TournamentTile) */
  .table {
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(21, 101, 192, 0.3);
    border: 3px solid #1565C0;
  }
  .thead {
    display: grid;
    grid-template-columns: 50px 1fr 100px;
    gap: 10px;
    padding: 10px 14px;
    background: linear-gradient(180deg, #1976D2 0%, #1565C0 100%);
    color: #fff;
    font-size: 11px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    font-weight: 800;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    border-bottom: 2px solid #0D47A1;
  }
  .thead .score { text-align: right; }

  .tbody {
    display: flex;
    flex-direction: column;
    background: #d9c9a8;
  }

  .row {
    display: grid;
    grid-template-columns: 50px 1fr 100px;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: #faf5ec;
    color: #0D47A1;
    border-left: 2px solid #d9c9a8;
    border-right: 2px solid #d9c9a8;
    transition: all 0.15s ease;
  }
  .row:nth-child(odd) {
    background: #fff;
  }
  .row:hover {
    background: #f0e7d5;
    transform: scale(1.005);
    z-index: 1;
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.15);
  }
  .row.me {
    background: linear-gradient(90deg, rgba(76, 175, 80, 0.18), rgba(76, 175, 80, 0.06));
    border-left-color: #4caf50;
    font-weight: 700;
  }
  .row.top1 {
    background: linear-gradient(90deg, rgba(255, 195, 0, 0.18), rgba(255, 195, 0, 0.06));
    border-left-color: #ffb300;
  }
  .row.top2 {
    background: linear-gradient(90deg, rgba(176, 190, 197, 0.18), rgba(176, 190, 197, 0.06));
    border-left-color: #90a4ae;
  }
  .row.top3 {
    background: linear-gradient(90deg, rgba(205, 127, 50, 0.18), rgba(205, 127, 50, 0.06));
    border-left-color: #b87333;
  }

  .pos {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pos .num {
    font-weight: 900;
    font-size: 14px;
    color: #1976D2;
  }
  .pos :global(.crown-1) { color: #ffb300; filter: drop-shadow(0 1px 0 rgba(0, 0, 0, 0.2)); }
  .pos :global(.medal-2) { color: #90a4ae; }
  .pos :global(.medal-3) { color: #b87333; }

  .player {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }
  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #1565C0;
    background: #faf5ec;
    flex-shrink: 0;
  }
  .nick {
    font-weight: 800;
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .me-tag {
    font-size: 9px;
    font-weight: 900;
    color: #2e7d32;
    background: rgba(76, 175, 80, 0.2);
    padding: 2px 6px;
    border-radius: 4px;
    letter-spacing: 0.5px;
  }

  .score {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 5px;
    font-weight: 800;
    font-size: 14px;
    color: #1565C0;
  }

  @media (max-width: 480px) {
    .thead, .row {
      grid-template-columns: 38px 1fr 80px;
      gap: 6px;
      padding: 8px 10px;
    }
    .nick { font-size: 12px; }
    .score { font-size: 12px; }
    .avatar { width: 24px; height: 24px; }
  }
</style>
